// Import model
import { UpdateFpRoomRequest } from '../models/UpdateFpRoomRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { UpdateDoorRequest } from '../models/UpdateDoorRequest';
import { UpdateSurfaceRequest } from '../models/UpdateSurfaceRequest';

// Import dependency serializers (for complex types)
import { UpdateDoorRequestSerializer } from './UpdateDoorRequestSerializer';
import { UpdateSurfaceRequestSerializer } from './UpdateSurfaceRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateFpRoomRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateFpRoomRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateFpRoomRequest instance
   */
  static deserialize(json: string): UpdateFpRoomRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateFpRoomRequest instance
   */
  static fromObject(obj: any): UpdateFpRoomRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateFpRoomRequest');
    }


    const instance: UpdateFpRoomRequest = {
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      existingSubfloorId: obj['existingSubfloorId'] as string | undefined,
      removeExistingFloorId: obj['removeExistingFloorId'] as string | undefined,
      furnitureToMoveId: obj['furnitureToMoveId'] as string | undefined,
      appliances: obj['appliances'] as number | undefined,
      bathroomFixtures: obj['bathroomFixtures'] as number | undefined,
      heavyItemsToMove: obj['heavyItemsToMove'] as number | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      perimeter: obj['perimeter'] as number | undefined,
      totalArea: obj['totalArea'] as number | undefined,
      doors: obj['doors'] ? (obj['doors'] as any[]).map((item: any) =>
        UpdateDoorRequestSerializer.fromObject(item)
      ) : [] as any,
      surfaces: obj['surfaces'] ? (obj['surfaces'] as any[]).map((item: any) =>
        UpdateSurfaceRequestSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateFpRoomRequest instances
   */
  static deserializeArray(json: string): UpdateFpRoomRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateFpRoomRequest instance to a JSON string
   */
  static serialize(instance: UpdateFpRoomRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateFpRoomRequest instance to a plain object
   */
  static toObject(instance: UpdateFpRoomRequest): any {
    return {
      'name': instance.name,
      'description': instance.description,
      'existingSubfloorId': instance.existingSubfloorId,
      'removeExistingFloorId': instance.removeExistingFloorId,
      'furnitureToMoveId': instance.furnitureToMoveId,
      'appliances': instance.appliances,
      'bathroomFixtures': instance.bathroomFixtures,
      'heavyItemsToMove': instance.heavyItemsToMove,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'perimeter': instance.perimeter,
      'totalArea': instance.totalArea,
      'doors': instance.doors?.map((item: any) =>
        UpdateDoorRequestSerializer.toObject(item)
      ),
      'surfaces': instance.surfaces?.map((item: any) =>
        UpdateSurfaceRequestSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of UpdateFpRoomRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateFpRoomRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
